import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../contexts/ThemeContext';
import Card from '../../components/UI/Card';
import { Calendar, Users, MapPin, Clock } from 'lucide-react';

const EventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Title = styled.h1`
  font-size: ${props => props.theme.typography.fontSize['2xl']};
  font-weight: ${props => props.theme.typography.fontWeight.semibold};
  color: ${props => props.theme.colors.text.primary};
  font-family: ${props => props.theme.typography.fontFamily.heading};
  margin: 0;
`;

const EventsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
`;

const EventCard = styled(Card)`
  padding: 1.5rem;
`;

const EventHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const EventIcon = styled.div`
  width: 50px;
  height: 50px;
  background-color: ${props => props.theme.colors.primary + '20'};
  border-radius: ${props => props.theme.borderRadius.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.primary};
`;

const EventTitle = styled.h3`
  font-size: ${props => props.theme.typography.fontSize.lg};
  font-weight: ${props => props.theme.typography.fontWeight.semibold};
  color: ${props => props.theme.colors.text.primary};
  font-family: ${props => props.theme.typography.fontFamily.heading};
  margin: 0;
`;

const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const EventDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: ${props => props.theme.typography.fontSize.sm};
  color: ${props => props.theme.colors.text.secondary};
  font-family: ${props => props.theme.typography.fontFamily.primary};
`;

const Events = () => {
  const { theme } = useTheme();
  
  const mockEvents = [
    {
      id: 1,
      title: 'International Women\'s Day Celebration',
      date: '2024-03-08',
      location: 'Addis Ababa, Ethiopia',
      participants: 200,
      type: 'conference'
    },
    {
      id: 2,
      title: 'Regional Women Human Rights Defenders Meeting',
      date: '2024-04-15',
      location: 'Hawassa, Ethiopia',
      participants: 50,
      type: 'meeting'
    },
    {
      id: 3,
      title: 'Youth Women Leaders Summit',
      date: '2024-06-20',
      location: 'Mekelle, Ethiopia',
      participants: 100,
      type: 'conference'
    }
  ];
  
  return (
    <EventsContainer theme={theme}>
      <Title theme={theme}>Events</Title>
      
      <EventsGrid theme={theme}>
        {mockEvents.map((event) => (
          <EventCard key={event.id} theme={theme}>
            <EventHeader theme={theme}>
              <EventIcon theme={theme}>
                <Calendar size={24} />
              </EventIcon>
              <EventTitle theme={theme}>{event.title}</EventTitle>
            </EventHeader>
            
            <EventInfo theme={theme}>
              <EventDetail theme={theme}>
                <Calendar size={16} />
                {new Date(event.date).toLocaleDateString()}
              </EventDetail>
              <EventDetail theme={theme}>
                <MapPin size={16} />
                {event.location}
              </EventDetail>
              <EventDetail theme={theme}>
                <Users size={16} />
                {event.participants} participants
              </EventDetail>
              <EventDetail theme={theme}>
                <Clock size={16} />
                {event.type}
              </EventDetail>
            </EventInfo>
          </EventCard>
        ))}
      </EventsGrid>
    </EventsContainer>
  );
};

export default Events;
